<template>
  <div style="margin: 0 5%">
    <h1 style="font-weight: bold" align="left"> 单据编号:{{ this.$route.query.fbillno }}</h1>
    <a-table :columns="columns" :data-source="data" :loading="loading" :style="{background:'url('+imagePath+')'}">
<!--      <a slot="fid" slot-scope="text" @click="closeSchmearpost(text)">{{ text }}</a>-->
    </a-table>
    <br/>

  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "pickData",
  data() {
    return {
      imagePath: require('../assets/bj7.jpg'),
      data: [],
      loading: true,
      columns: [
        {
          title: '材料代码',
          dataIndex: 'fnumber',
          key: 'fnumber',
        },
        {
          title: '名称',
          dataIndex: 'fname',
          key: 'fname',
        },
        {
          title: '描述',
          dataIndex: 'fspecification',
          key: 'fspecification',
        },
        {
          title: '应发数量',
          dataIndex: 'fstdqty',
          key: 'fstdqty',
        },
        {
          title: '实发数量',
          dataIndex: 'fbasepickedqty',
          key: 'fbasepickedqty',
        },
      ]
    }
  },
  mounted() {
    axios.get("http://www.tcnanhua.com:5555/t-nh-pickdata/selectYNhPickDataByFMOBILLNO?FMOBILLNO=" + this.$route.query.fbillno)
      .then((res) => {
        this.loading = false;
        this.data = res.data.data;
      })
  },
  methods: {

  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/PickData.vue